<div class="header">
   <div class="left-header">
      <a href="/" class="logo"></a>
      <h1> <a href="/">Education Loan</a></h1>
   </div>
   <div class="right-header">
      <img src="assets/images/sf_logo.png" alt="Logo2" class="logo2" />
   </div>
   <!-- <div class="right-header"></div>
      <a href="/" >Check Status</a>
      <a href="/" >Contact us</a>
   </div> -->
</div>